document.addEventListener('DOMContentLoaded', function () {

  let closeAllFilters = () => {
      var filterParents = document.querySelectorAll('.filter_parent')

      filterParents.forEach(parent => {
          parent.querySelector('.filter_title')
          .classList.remove('border', 'border-black')

          parent.querySelector('.filter_list')
          .classList.add('hidden')

          parent.querySelector('.filter_overlay')
          .classList.add('hidden')
      })
  }
  
  var sortBys = document.querySelectorAll('#SortBy')

  sortBys.forEach( sortBy => {
      
      sortBy.addEventListener('change', (event) => {
          var href = new URL( window.location.href )
          href.searchParams.set('sort_by', sortBy.options[sortBy.selectedIndex].value)
          window.location.href = href
      })
  
  })

  var filterForm = document.querySelector('#FacetFiltersForm')

  filterForm.addEventListener('submit', (event) => {

    event.preventDefault()
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    const form = event.target.closest('form')
    const search = document.querySelector("form")['q'].value;
    var searchFormQuery = `?q=${search}&options%5Bprefix%5D=last&${searchParams}`

    window.location.href = window.location.href + searchFormQuery

  })

  var filters = document.querySelectorAll('.filter_title')
  var filtersClose = document.querySelectorAll('.filters_close')

  filters.forEach(filter => {
      
      filter.addEventListener('click', () => {
          closeAllFilters()
          var filters = filter.parentElement.querySelector('.filter_list')
          var overlay = filter.parentElement.querySelector('.filter_overlay')

          filters.classList.toggle('hidden')
          overlay.classList.toggle('hidden')
          filter.classList.toggle('border', 'border-black')
      })

  })

  filtersClose.forEach(close => {
      
      close.addEventListener('click', () => {
          var filters = close.parentElement.parentElement.parentElement.querySelector('.filter_list')
          var overlay = close.parentElement.parentElement.parentElement.querySelector('.filter_overlay')
          var title = close.parentElement.parentElement.parentElement.querySelector('.filter_title')

          filters.classList.add('hidden')
          overlay.classList.add('hidden')
          title.classList.remove('border', 'border-black')
      })

  })

  var productsDisplay = document.querySelector('#display_selector')

  productsDisplay.addEventListener('change', (event) => {
  
      var displayNum = event.target.value

      let formData = {
          'attributes' : {
              'pagination': displayNum
          }
         };
         fetch(window.Shopify.routes.root + 'cart/update.js/', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(formData)
         })
         .then(response => {
           return response.json();
         })
         .then(resp => {
              window.location.reload()
          })
         .catch((error) => {
           console.error('Error:', error);
         });
  
  })


  var mobileFilterAccordions = document.querySelectorAll('.filter_label')
  var mobileFilters = document.querySelector('.mobile_filters')
  var mobileFilterButton = document.querySelector('[data-filters-trigger]')
  var mobileFiltersClose = document.querySelector('.mobile-filters-close')

  mobileFilterAccordions.forEach(mobileFilter => {
      mobileFilter.addEventListener('click', () => {
        var filters = mobileFilter.parentElement.querySelector('.mobile_filter_list')
        filters.classList.toggle('max-h-full')
        mobileFilter.classList.toggle('active')
      })
  })

  mobileFilterButton.addEventListener('click', () => {
      
      mobileFilters.classList.add('mobile_filters--open')
      document.querySelector('body').classList.add('overflow-hidden')
      
  })

  mobileFiltersClose.addEventListener('click', () => {
      
      mobileFilters.classList.remove('mobile_filters--open')
      document.querySelector('body').classList.remove('overflow-hidden')
  
  })
  
})